<!--Da dinamic form module-->
<ng-container *ngIf="group && field">

    <div class="main-outer-container " [formGroup]="group" [hidden]="field!.hidden ? field.hidden: false">

        <h1 *ngIf="!field.tooltip" [id]="field.name" class="text-2xl" [class]="field!.cssClass">{{field!.label}}</h1>

        <div *ngIf="field.tooltip" class="flex gap-2 items-center justify-start">
            <h1 [id]="field.name" class="text-2xl " [class]="field!.cssClass" [matTooltip]="field.tooltip" matTooltipClass="font-bold text-xl">{{field!.label}}</h1>

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" [matTooltip]="field.tooltip" matTooltipClass="font-bold text-2xl"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="w-6 h-6">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                <path d="M12 9h.01" />
                <path d="M11 12h1v4h1" />
            </svg>
        </div>


    </div>

</ng-container>


<!--Da componente HTML-->
<ng-container *ngIf="!group">

</ng-container>